import { dummyImage } from '../../utils/icons';

const ImgEle = ({ url, foreign_landing_url, imageHyperLink, isDisableDefaultlLink }) => {
    const link = imageHyperLink || (isDisableDefaultlLink ? null : foreign_landing_url);
    console.log(foreign_landing_url);

    return link ? (
        <a href={link} className="img" target="_blank" rel="noopener noreferrer">
            {url ? <img src={url} alt="Image" /> : <div className='dummyImage'>{dummyImage}</div>}
        </a>
    ) : (
        <div className="img">
            {url ? <img src={url} alt="Image" /> : <div className='dummyImage'>{dummyImage}</div>}
        </div>
    );
};

export default ImgEle;


